/* tslint:disable */
/* eslint-disable */
/**
 * Kubernetes
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: unversioned
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { IoK8sApiCoreV1ContainerPortFromJSON, IoK8sApiCoreV1ContainerPortToJSON, } from './IoK8sApiCoreV1ContainerPort';
import { IoK8sApiCoreV1EnvFromSourceFromJSON, IoK8sApiCoreV1EnvFromSourceToJSON, } from './IoK8sApiCoreV1EnvFromSource';
import { IoK8sApiCoreV1EnvVarFromJSON, IoK8sApiCoreV1EnvVarToJSON, } from './IoK8sApiCoreV1EnvVar';
import { IoK8sApiCoreV1LifecycleFromJSON, IoK8sApiCoreV1LifecycleToJSON, } from './IoK8sApiCoreV1Lifecycle';
import { IoK8sApiCoreV1ProbeFromJSON, IoK8sApiCoreV1ProbeToJSON, } from './IoK8sApiCoreV1Probe';
import { IoK8sApiCoreV1ResourceRequirementsFromJSON, IoK8sApiCoreV1ResourceRequirementsToJSON, } from './IoK8sApiCoreV1ResourceRequirements';
import { IoK8sApiCoreV1SecurityContextFromJSON, IoK8sApiCoreV1SecurityContextToJSON, } from './IoK8sApiCoreV1SecurityContext';
import { IoK8sApiCoreV1VolumeDeviceFromJSON, IoK8sApiCoreV1VolumeDeviceToJSON, } from './IoK8sApiCoreV1VolumeDevice';
import { IoK8sApiCoreV1VolumeMountFromJSON, IoK8sApiCoreV1VolumeMountToJSON, } from './IoK8sApiCoreV1VolumeMount';
/**
 * Check if a given object implements the IoK8sApiCoreV1EphemeralContainer interface.
 */
export function instanceOfIoK8sApiCoreV1EphemeralContainer(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
export function IoK8sApiCoreV1EphemeralContainerFromJSON(json) {
    return IoK8sApiCoreV1EphemeralContainerFromJSONTyped(json, false);
}
export function IoK8sApiCoreV1EphemeralContainerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'args': !exists(json, 'args') ? undefined : json['args'],
        'command': !exists(json, 'command') ? undefined : json['command'],
        'env': !exists(json, 'env') ? undefined : (json['env'].map(IoK8sApiCoreV1EnvVarFromJSON)),
        'envFrom': !exists(json, 'envFrom') ? undefined : (json['envFrom'].map(IoK8sApiCoreV1EnvFromSourceFromJSON)),
        'image': !exists(json, 'image') ? undefined : json['image'],
        'imagePullPolicy': !exists(json, 'imagePullPolicy') ? undefined : json['imagePullPolicy'],
        'lifecycle': !exists(json, 'lifecycle') ? undefined : IoK8sApiCoreV1LifecycleFromJSON(json['lifecycle']),
        'livenessProbe': !exists(json, 'livenessProbe') ? undefined : IoK8sApiCoreV1ProbeFromJSON(json['livenessProbe']),
        'name': json['name'],
        'ports': !exists(json, 'ports') ? undefined : (json['ports'].map(IoK8sApiCoreV1ContainerPortFromJSON)),
        'readinessProbe': !exists(json, 'readinessProbe') ? undefined : IoK8sApiCoreV1ProbeFromJSON(json['readinessProbe']),
        'resources': !exists(json, 'resources') ? undefined : IoK8sApiCoreV1ResourceRequirementsFromJSON(json['resources']),
        'securityContext': !exists(json, 'securityContext') ? undefined : IoK8sApiCoreV1SecurityContextFromJSON(json['securityContext']),
        'startupProbe': !exists(json, 'startupProbe') ? undefined : IoK8sApiCoreV1ProbeFromJSON(json['startupProbe']),
        'stdin': !exists(json, 'stdin') ? undefined : json['stdin'],
        'stdinOnce': !exists(json, 'stdinOnce') ? undefined : json['stdinOnce'],
        'targetContainerName': !exists(json, 'targetContainerName') ? undefined : json['targetContainerName'],
        'terminationMessagePath': !exists(json, 'terminationMessagePath') ? undefined : json['terminationMessagePath'],
        'terminationMessagePolicy': !exists(json, 'terminationMessagePolicy') ? undefined : json['terminationMessagePolicy'],
        'tty': !exists(json, 'tty') ? undefined : json['tty'],
        'volumeDevices': !exists(json, 'volumeDevices') ? undefined : (json['volumeDevices'].map(IoK8sApiCoreV1VolumeDeviceFromJSON)),
        'volumeMounts': !exists(json, 'volumeMounts') ? undefined : (json['volumeMounts'].map(IoK8sApiCoreV1VolumeMountFromJSON)),
        'workingDir': !exists(json, 'workingDir') ? undefined : json['workingDir'],
    };
}
export function IoK8sApiCoreV1EphemeralContainerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'args': value.args,
        'command': value.command,
        'env': value.env === undefined ? undefined : (value.env.map(IoK8sApiCoreV1EnvVarToJSON)),
        'envFrom': value.envFrom === undefined ? undefined : (value.envFrom.map(IoK8sApiCoreV1EnvFromSourceToJSON)),
        'image': value.image,
        'imagePullPolicy': value.imagePullPolicy,
        'lifecycle': IoK8sApiCoreV1LifecycleToJSON(value.lifecycle),
        'livenessProbe': IoK8sApiCoreV1ProbeToJSON(value.livenessProbe),
        'name': value.name,
        'ports': value.ports === undefined ? undefined : (value.ports.map(IoK8sApiCoreV1ContainerPortToJSON)),
        'readinessProbe': IoK8sApiCoreV1ProbeToJSON(value.readinessProbe),
        'resources': IoK8sApiCoreV1ResourceRequirementsToJSON(value.resources),
        'securityContext': IoK8sApiCoreV1SecurityContextToJSON(value.securityContext),
        'startupProbe': IoK8sApiCoreV1ProbeToJSON(value.startupProbe),
        'stdin': value.stdin,
        'stdinOnce': value.stdinOnce,
        'targetContainerName': value.targetContainerName,
        'terminationMessagePath': value.terminationMessagePath,
        'terminationMessagePolicy': value.terminationMessagePolicy,
        'tty': value.tty,
        'volumeDevices': value.volumeDevices === undefined ? undefined : (value.volumeDevices.map(IoK8sApiCoreV1VolumeDeviceToJSON)),
        'volumeMounts': value.volumeMounts === undefined ? undefined : (value.volumeMounts.map(IoK8sApiCoreV1VolumeMountToJSON)),
        'workingDir': value.workingDir,
    };
}
